'use client';

import { MultiColumnDisplay } from '@kohler-dsm-library/kohler-modules';
import { Button } from '@kohler-dsm-library/kohler-core';
import { useRouter } from 'next/navigation';
/**
 * @param {Object} props - Component props
 * @param {string} props.componentType - Component type identifier
 * @param {Object} props.multiColumnDisplay - multiColumnDisplay props
 */

const MultiColumnDisplayWithButtons = ({
  componentType = 'multi-column-display-with-buttons',
  multiColumnDisplay = {},
  button = {},
}) => {
  const router = useRouter();

  const handleClick = (btn) => {
    const { href, newtab, onClick } = btn;

    // preserve any existing click handler
    if (onClick) onClick();

    if (!href) return;

    if (newtab) {
      window.open(href, '_blank', 'noopener,noreferrer');
    } else {
      router.push(href);
    }
  };

  return (
    <div className={`MultiColumnDisplayWithButtons`} data-component-type={componentType}>
      {/* MultiColumnDisplay section */}
      {multiColumnDisplay && Object.keys(multiColumnDisplay).length > 0 && (
        <div className="MultiColumnDisplayWithButtons__content">
          <MultiColumnDisplay {...multiColumnDisplay} />
        </div>
      )}
      {/* button section */}
      {button?.ctas && Array.isArray(button.ctas) && button.ctas.length > 0 && (
        <div className="button__content">
          {button.ctas.map((btn, index) => (
            <Button key={index} {...btn} onClick={() => handleClick(btn)} />
          ))}
        </div>
      )}
    </div>
  );
};

export default MultiColumnDisplayWithButtons;
